import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

const i18nRoot = "admin_dashboard.analytics.audience.empty_state";

interface AudienceEmptyStateProps {
  onInviteMembers?: () => void;
}

export const AudienceEmptyState = ({
  onInviteMembers,
}: AudienceEmptyStateProps) => (
  <div className="bg-secondary flex flex-col items-center justify-center rounded-lg px-6 py-12">
    <Icon type="20-members" size={24} className="text-light mb-4" />
    <div className="mb-2">
      <Typography.TitleSm weight="semibold">
        {t([i18nRoot, "title"])}
      </Typography.TitleSm>
    </div>
    <div className="mb-6 text-center">
      <Typography.BodySm color="text-light">
        {t([i18nRoot, "description"])}
      </Typography.BodySm>
    </div>
    <Button variant="circle" onClick={onInviteMembers}>
      {t([i18nRoot, "invite_button"])}
    </Button>
  </div>
);
